import { Link as ReactRouterLink } from 'react-router-dom';
import { styled } from 'styled-components';

const StyledLink = styled(ReactRouterLink)`
	color: ${({ theme }) => theme.colors.textDefault};
`;

export default StyledLink;
